import React from 'react';
import { useModal } from '@hooks';
import ExportViaEmailModal from '../components/ExportViaEmailModal';

export const useExportViaEmailModal = () => {
    const { open, close } = useModal();

    const openModal = ({ userEmail, onSubmit }) =>
        open({
            title: <span>Export via Email</span>,
            content: <ExportViaEmailModal close={close} userEmail={userEmail} onSubmit={onSubmit} />,
            settings: {
                width: '560px'
            }
        });

    return { openModal };
};
